import type { MiddlewareParams } from '@haaretz/s-types';

export default function cookieDispenserMiddleware({ ctx }: MiddlewareParams) {
  const cookie = ctx.req.headers.cookie;

  return Promise.resolve({ cookie: cookie || '' });
}
